// extracted by mini-css-extract-plugin
export var addressFields = "_fg-0";
export var animationContainer = "_fg-1";
export var footer = "_fg-2";
export var lineItems = "_fg-3";
export var modalContent = "_fg-4";
export var orderName = "_fg-5";
export var strong = "_fg-6";
export var warning = "_fg-7";